import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import api from '@/shared/api';
import config from '@/config';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
export const SharepointFileSelector = ({ siteId, driveId, folderId, selectedFileId, onFileSelected, }) => {
    var _a, _b;
    const [files, setFiles] = useState([]);
    useEffect(() => {
        if (!siteId || !driveId || !folderId)
            return;
        const url = !!folderId && folderId !== '/'
            ? `${config.appUrls.documents}/api/sharepoint/sites/${siteId}/drives/${driveId}/folders/${folderId}/files`
            : `${config.appUrls.documents}/api/sharepoint/sites/${siteId}/drives/${driveId}/files`;
        api.base.get(url).then(x => setFiles(x.data));
    }, [siteId, driveId, folderId]);
    return (_jsx(AutoComplete, { mode: "edit", disabled: files.length < 1, items: files.map(f => ({ key: f.id, label: f.name })), value: selectedFileId ? { key: selectedFileId, label: (_b = (_a = files.find(f => f.id === selectedFileId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '' } : null, onChange: item => { var _a, _b, _c; return onFileSelected((_b = (_a = files.find(f => f.id === (item === null || item === void 0 ? void 0 : item.key))) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null, (_c = item === null || item === void 0 ? void 0 : item.key) !== null && _c !== void 0 ? _c : null); } }));
};
